import { useAppContext } from "../contexts/AppContext";

const AUTH_MAP = {
  USER: "user",
  MOD: "mod",
  ADMIN: "admin",
} as const;

export const useHasRole = (role: "USER" | "MOD" | "ADMIN") => {
  const { whoami } = useAppContext();

  return Boolean(whoami?.roles[AUTH_MAP[role]]);
};
